import { render } from "./FutureRewardValue.vue?vue&type=template&id=1b59bfe0"
import script from "./FutureRewardValue.vue?vue&type=script&lang=js"
export * from "./FutureRewardValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__